import React, { useState } from "react"
import { useStaticQuery, graphql, navigate } from "gatsby"
import styled, { css } from "styled-components"
import { media } from "utils/Media"
import WPLink from "components/shared/WPLink"
import Button from "components/shared/Button"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCaretDown } from "@fortawesome/free-solid-svg-icons"

const Nav = styled.nav`
  display: none;
  background: white;
  position: absolute;
  z-index: 10;
  width: 100%;
  border-top: 3px solid ${props => props.theme.colors.secondary};
  padding: 1rem 0 0 0;

  ${props => props.active && css`
    display: block;

    @media ${media.nav} {
      display: none;
    }
  `}

  ul {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      a, span {
        color: ${props => props.theme.colors.primary};
      }
      &.sign-up{
        background: #ECF9FF;
        a {
          width: 100%;
          display: block;
          padding: .75rem;
          text-align: center;
          font-family: ${props => props.theme.font.family.bold};
        }
      }
    }
  }
`

const MobileMenuItemStyled = styled.li`
  .link-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1.5rem;

    svg {
      width: 20px;
      height: 20px;
      position: relative;
    }

    a, span {
      font-family: ${props => props.theme.font.family.bold};
      padding: .5rem 0;
      cursor: pointer;
      padding: .5rem;
      display: block;

      ${props => props.active && css`
        color: ${props => props.theme.colors.secondary};
      `}
    }
  }

  a, span {
    padding: .5rem 0;
  }

  a span {
    padding: 0 !important;
  }

  ${props => props.open && css`
    .link-wrap {
      color: ${props => props.theme.colors.secondary};
      a, span {
        color: ${props => props.theme.colors.secondary};
      }
      svg {
        transform: rotate(180deg);
      }
    }
  `}
`

const SubMenu =  styled.div`
  display: none;
  padding: 0;
  background-color: ${props => props.theme.colors.white};
  justify-content: center;

  ul.sub-menu-ul {
    padding: 1rem;
    background: #F7F7F7;
    li {
      border: none;
      a {
        text-transform: none;
        padding: .5rem 2rem;
        display: block;
        color: ${props => props.theme.colors.primary};
      }
      span {
        text-transform: none;
        color: ${props => props.theme.colors.primary};
        font-family: ${props => props.theme.font.family.bold};
      }

      &.active {
        a, span {
          color: ${props => props.theme.colors.secondary}; 
        }
      }
    }
  }

  .title {
    color: ${props => props.theme.colors.secondary} !important;
    font-size: 1.1rem;
  }

  ${props => props.open && css`
    display: block;
  `}
`

export default function NavMobile({navActive, currentPath}) {
  const data = useStaticQuery(graphql`
    query {
      allWpMenu(filter: {locations: {eq: PRIMARY}}) {
        edges {
          node {
            menuItems {
              nodes {
                url
                target
                label
                parentDatabaseId
                acfMenu {
                  image {
                    altText
                    sourceUrl
                    localFile {
                      childImageSharp {
                        gatsbyImageData(width: 356, quality: 95, placeholder: NONE, layout: CONSTRAINED)
                      }
                    }
                  }
                }
                childItems {
                  nodes {
                    url
                    target
                    label
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  const { menuItems } = data.allWpMenu.edges[0].node

  const menu = menuItems.nodes.map((node, i) => {
    return node.parentDatabaseId === 0 ? <MobileMenuItem item={node} key={node.databaseId} currentPath={currentPath} /> : null
  })

  const scrollToEmail = (e) => {
    e.preventDefault()
    const el = document.getElementById('newsletter-signup')
    if (!el) {
      navigate("/#newsletter-signup")
    }
  }

  return(
    <Nav active={navActive}>
      <ul>
        {menu}
        <li className="sign-up">
          <a href="/#newsletter-signup" onClick={scrollToEmail}>Sign Up</a>
        </li>
      </ul>
    </Nav>
  )
}

const MobileMenuItem = ({item, currentPath}) => {
  const [open, setOpen] = useState(false)
  const hasChildren = !!item.childItems.nodes && !!item.childItems.nodes.length

  const toggleDropdown = () => {
    setOpen(!open)
  }

  return(
    <MobileMenuItemStyled open={open} active={currentPath === item.url}>
      <div className="link-wrap">
        {hasChildren ? (
          <span dangerouslySetInnerHTML={{ __html: item.label }} onClick={toggleDropdown} />
        ) : (
          <WPLink url={item.url} target={item.target}>
            <span dangerouslySetInnerHTML={{ __html: item.label }} />
          </WPLink>
        )}
        {hasChildren && (
          <FontAwesomeIcon icon={faCaretDown} onClick={toggleDropdown} />
        )}
      </div>

      {hasChildren && (
        <SubMenu className="sub-menu" open={open}>
          <ul className="sub-menu-ul">
            {item.childItems.nodes.map((node, i) => {
              return(
                <li className={`${currentPath === node.url ? "active" : ""}`}>
                  <WPLink url={node.url} target={node.target}>
                    <span dangerouslySetInnerHTML={{ __html: node.label }} />
                  </WPLink>
                </li>
              )
            })}
          </ul>
        </SubMenu>
      )}
    </MobileMenuItemStyled>
  )
}